import { authApi } from "../api";
import { login } from "./authReducer";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";
import { getProfile } from "./userReducer";

interface ISettings {
  language: string,
  isInitialized: boolean
}
const initialState: ISettings = {
  language: 'ru',
  isInitialized: false
}

// Action types
export const CHANGE_LANGUAGE = 'settings/CHANGE_LANGUAGE';
export const INITIALIZE = 'settings/INITIALIZE';

// Selectors
export const languageSelector = (state: any) => state.settings.language;
export const initializeSelector = (state: any) => state.settings.isInitialized;

// Reducer
export function settingsReducer(state = initialState, action: any) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload
      }
    case INITIALIZE:
      return {
        ...state,
        isInitialized: true
      }

    default:
      return state;
  }
}

// Actions
interface InitializeType {
  type: typeof INITIALIZE
}
export function initialize(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    const language = localStorage.getItem('language');
    if (language) {
      dispatch(setLanguage(language));
    }
    const islogined = await authApi.isLogined();
    dispatch({
      type: INITIALIZE
    });
    if (islogined) {
      dispatch(login());
      dispatch(getProfile())
    }
  }
}

interface SetLanguageType {
  type: typeof CHANGE_LANGUAGE,
  payload: string
}
export function setLanguage(payload: string) {
  localStorage.setItem('language', payload);
  return {
    type: CHANGE_LANGUAGE,
    payload
  }
}

export type SettingsActions =
  SetLanguageType
  | InitializeType;